import { useLDClient } from "launchdarkly-react-client-sdk"
import { useEffect, useState } from "react"
import { useUser } from "./useUser"

/**
 * Identifies the current user to LaunchDarkly and returns whether
 * the identification is complete. Gates downstream routing decisions
 * so they don't act on stale bootstrapped flags.
 */
export function useLDIdentify() {
  const ldClient = useLDClient()
  const user = useUser()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (!ldClient || !user?.userId) return

    let cancelled = false

    void ldClient
      .identify({
        kind: "user",
        key: user.userId,
        name: user.name,
        organization: user.orgName,
        role: user.roles[0],
      })
      .then(
        () => {
          if (!cancelled) setIsReady(true)
        },
        () => {
          console.error("Failed to identify user to LaunchDarkly")
          if (!cancelled) setIsReady(true)
        }
      )

    return () => {
      cancelled = true
    }
  }, [ldClient, user])

  if (!ldClient || !user?.userId) return false

  return isReady
}
